import { render, staticRenderFns } from "./BncEnLineaPay.vue?vue&type=template&id=6acfc8c4&scoped=true"
import script from "./BncEnLineaPay.vue?vue&type=script&lang=js"
export * from "./BncEnLineaPay.vue?vue&type=script&lang=js"
import style0 from "./BncEnLineaPay.vue?vue&type=style&index=0&id=6acfc8c4&prod&lang=less&scoped=true"
import style1 from "./BncEnLineaPay.vue?vue&type=style&index=1&id=6acfc8c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acfc8c4",
  null
  
)

export default component.exports